<div class="loader">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>